export enum PopupSegmentedOptionValue {
    Camera = "camera",
    Record = "record",
    Story = "story",
}